import React, { ReactElement } from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import Page from '../../components/Page';

const ProfilePage: React.FC<RouteComponentProps> = (props): ReactElement => {
  const { match } = props;

  return (
    <Page title="Perfil" isPrivate>
      <p>
        <Link to={`${match.url}/enderecos`}>Endereços</Link>
      </p>

      <p>
        <Link to="sair/">Sair</Link>
      </p>
    </Page>
  );
};

export default withRouter(ProfilePage);
